import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createPasswordlessSession, createSession } from '../../../entities/auth/session/actions';
import { IThunkDispatch } from '../../../store/middleware';
import { IState } from '../../../store/reducer';
import { Login as LoginComponent } from './Login';
import { requestPasswordReset } from './reset/actions';

const mapStateToProps = (state: IState) => ({
	currentSession: state.entities.auth.session.current,
});

export const Login = () => {

	const navigate = useNavigate();

	const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
		onSubmitEmailAndPassword: async (username: string, password: string) => {
			await dispatch(createSession(username, password));
		},
		onConfirmPasswordlessLogin: async (username: string, session: string, code: string) => {
			await dispatch(createPasswordlessSession(username, session, code));
		},
		onResetPassword: async (email: string) => {
			await dispatch(requestPasswordReset(email, navigate));
		}
	});

	const props = {
		...useSelector(mapStateToProps),
		...mapDispatchToProps(useDispatch())
	};

	return (
		<LoginComponent {...props}/>
	);
};
